import { useEffect, useState } from 'react';

import { apiFetchOrg } from 'api/org/apiOrg';
import { Box } from 'components/Box';
import { Link } from 'components/Link';
import { SearchContextHeader } from 'components/Search/SearchContextHeader';
import { Body } from 'components/Text/Body';
import { SearchContextHeaderData } from 'containers/SearchContextHeader/SearchContextHeaderData';
import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import { Layout } from 'layouts/Layout/Layout';
import { gutterWidth, maxWidth } from 'theme/theme';

type Props = {
  orgId: string | undefined;
  url: Record<UserLocale, string> | undefined;
  searchContext: SearchContextHeaderData | undefined;
};

export function ViewOrgPageUnpublished({ orgId, url, searchContext }: Props) {
  const [showAdminUrl, setShowAdminUrl] = useState(false);

  /* TRANSLATORS: 404 page title */
  useSetDocumentTitle(getText('Page Not Found'));

  useEffect(() => {
    if (orgId) {
      apiFetchOrg(orgId).then((org) => setShowAdminUrl(org.type === 'ORG'));
    }
  }, [orgId]);

  return (
    <Layout>
      <Box
        mx="auto"
        maxWidth={[480, null, maxWidth[3]]}
        p={[gutterWidth / 2, null, null, gutterWidth]}
      >
        <Box display={['block', null, 'flex']} alignItems="center">
          <Box textAlign="center" width={1} pr={[0, null, gutterWidth]}>
            {searchContext && (
              <Box mb={[4, 4, 4, '40px']}>
                <SearchContextHeader searchContext={searchContext} />
              </Box>
            )}
            <Body>
              {
                /* TRANSLATORS: 404 page copy */
                getText(
                  'Whoops! This organization listing was unpublished while you were browsing.',
                )
              }
            </Body>

            {url && url[CURRENT_LOCALE] && showAdminUrl ? ( // eslint-disable-line @typescript-eslint/prefer-optional-chain
              <Box display="flex" justifyContent="center" alignItems="center">
                <Link href={url[CURRENT_LOCALE]} data-qa-id="view-profile-link">
                  {getText("View this organization's profile")}
                </Link>
              </Box>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}
